<template>
    <modal @close="clearSelectedItem" dialog="modal-lg" class="dark-top" :customClass="'heightAuto'" :footer="false">
        <div slot="title">
            <h2>Category details</h2>
            <h3 v-if="getSelectedItem">{{ getSelectedItem.name }}</h3>
        </div>

        <div slot="body">
            <div class="m-4">
            <!-- <tabs> -->
                <!-- <tab name="Overview">
                    <overview></overview>
                </tab> -->
                <!-- <tab name="Details"> -->
                    <category-edit></category-edit>
                <!-- </tab> -->
            <!-- </tabs> -->
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import Overview from '@/components/inventory/categories/CategoryOverview'
    import CategoryEdit from '@/components/inventory/categories/CategoryEdit'

    export default {
        methods: {
            ...mapActions([
                'clearSelectedItem'
            ]),
        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
            ])
        },
        components: {
            Modal,
            CategoryEdit,
            Overview,
        }
    }
</script>



// WEBPACK FOOTER //
// CategoryView.vue?6a199a29